import React from "react";
import { Link } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import LogoutPage from './Logout';
import { useContext } from "react";
import { UserContext } from "../../../context/UserContext";
const Header = () => {
  const {curPath} = useContext(UserContext)
  var path = curPath.split("/");
  var name = path[path.length - 1].split("-");
  var finalName = name.length >= 3 ? name.filter((n, i) => i > 0) : name;
 
  return ( 
    <div className="header border-bottom">
      <div className="header-content">
        <nav className="navbar navbar-expand">
          <div className="collapse navbar-collapse justify-content-between">
            <div className="header-left">
				<div
					className="dashboard_bar"
					style={{ textTransform: "capitalize" }}
				  >
					{finalName.join(" ").length === 0
					  ? "Add Transaction"
					  : finalName.join(" ")}
				</div>
            </div>
            <ul className="navbar-nav header-right main-notification">
				<Dropdown as="li" className="nav-item dropdown header-profile">
					<Dropdown.Toggle variant="" as="a" className="nav-link i-false c-pointer"
						role="button" data-toggle="dropdown"
					>
						<img src={"https://ui-avatars.com/api/?name=" + localStorage.getItem("username") + "&background=random&color=000000&format=svg"} width={20} alt="" />
					</Dropdown.Toggle>
					<Dropdown.Menu align="right" className="mt-3 dropdown-menu dropdown-menu-end">
					  <LogoutPage />
					</Dropdown.Menu>
				</Dropdown>
			  
				{/* <li className="nav-item header-profile">
					<Link to={"#"} className="nav-link" role="button" data-bs-toggle="dropdown">
						<img src={profile} width="20" alt=""/>
					</Link>
				</li> */}
            </ul>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Header;
